<template>
    <el-dialog v-model="param.view" title="vip退款" width="25%" :before-close="handleClose">
        <el-form inline="false">
            <el-form-item>
                <label class="TTL-form-label">退款金额<i>*</i></label>
                <wcinput :option="{placeholder:'请选择退订金额',type:'input',clearable:true,ischange:true,width:'100%',isinput:true,clearable:true}" 
                    :value="param.money"
                    @finish="(val)=> {
                        param.money=val.value;
                    }"
                />
            </el-form-item> 
            <el-form-item>
                <label class="TTL-form-label">退订时间（天）<i>*</i></label>
                <wcinput :option="{placeholder:'请选择退订时间',type:'input',clearable:true,ischange:true,width:'100%',isinput:true,clearable:true}" 
                    :value="param.day"
                    @finish="(val)=> {
                        param.day=val.value;
                    }"
                />
            </el-form-item> 
        </el-form>
        <div class="er-vip-box">
            <wcbutton :option="{title:'取消',type:'del'}"  
                @finish="(val) => {
                    this.handleClose();
                }"
            />
            <wcbutton :option="{title:'完成'}"  class="left10"
                @finish="(val) => {
                    this.UpdateVipRefund();
                }"
            />
        </div>
    </el-dialog>
</template>

<script>
import INTERFACE_MODEL_VIP from '@/Interface/Es/vip';
export default {
    props:['view','memberid'],
    data() {
        return {
            param: {
                view:false,
                memberid:'',
                money:'',
                day:''
            },
        }
    },
    watch: {
        view(val){
            if(val) {
                this.param.view=true;
                this.param.memberid=this.memberid;
                this.GetRefundInfos();
            }
        },
    },
    mounted() {
        
    },
    methods: {


        /** 获取可退vip续费信息 **/
        GetRefundInfos() {
            INTERFACE_MODEL_VIP.GET_VIP_RENEW_CANCEL({memberid:this.param.memberid}).then(res=>{
                this.param.money=res.data.money;
                this.param.day=res.data.day;
            })
        },


        /** 关闭窗口 **/
        handleClose() {
            this.param.view=false;
            this.$emit('finish');
        },


        /** 提交vip退款信息 **/
        UpdateVipRefund() {
            var param={
                memberid:this.param.memberid,
                money:this.param.money,
                day:this.param.day
            }
            INTERFACE_MODEL_VIP.EDIT_VIP_RENEW_CANCEL(param).then(res=>{
                this.handleClose();
            })
        },



    },
}
</script>
<style scoped>
.auth-box {display: inline-block;width:100%;}
.auth-box-item {display: inline-flex;align-items: center;width:100%;position:relative;}
.auth-title {display: inline-flex;align-items: center;font-size:16px;font-weight: bold;}
.auth-title span {font-size:12px;line-height: 12px;color:#666666;padding:4px 10px;border-radius: 20px;border:1px solid #666666;font-weight: normal;}
.auth-status {color:#ffffff !important;background-color: #666eeb;border-color:#666eeb !important;}
.auth-box-content-title {display: inline-block;font-size:13px;color:#333333;width:25%;}
.auth-box-content {display: inline-block;font-size:13px;color:#333333;}
.auth-error {font-size:13px;color:red !important;border:none !important;}
.TTL-btn-box {display: inline-flex;justify-content: flex-end;align-items: center;width:100%;margin-bottom:20px;}
.expire-time {display: inline-block;width:100%;text-align: center;}
.er-vip-box {display: inline-flex;width:100%;justify-content: flex-end;align-items: center;}
</style>